import { getCurrentEnvironment } from './env-utilities';

const WEBSOCKET_ENDPOINTS = {
  development: 'wss://sandbox.sherlock-virtual-agent.genesyspsdevops-dev.com',
  test: 'wss://uat.sherlock-virtual-agent.genesyspsdevops-dev.com',
  production: 'wss://test.sherlock-virtual-agent.genesyspsdevops-dev.com',
  local: 'wss://sandbox.sherlock-virtual-agent.genesyspsdevops-dev.com',
} as const;

export const getWebSocketEndpoint = (): string => {
  const customEndpoint = import.meta.env.VITE_WEBSOCKET_ENDPOINT;
  if (customEndpoint) {
    return customEndpoint;
  }

  const env = getCurrentEnvironment();
  return WEBSOCKET_ENDPOINTS[env as keyof typeof WEBSOCKET_ENDPOINTS] || WEBSOCKET_ENDPOINTS.development;
};
